module.exports = require("ramda/src/slice");